/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Hidden } from "@material-ui/core";
import CoverageSummary from "../../components/CoverageSummary";
import PersonalInfoCard from "../../components/PersonalInfoCard";
import PersonalInfoForm from "../../components/PersonalInfoForm";
import WizardLayout from "../../components/WizardLayout";
import WizardNavigation from "../../components/WizardNavigation";
import api from "../../api";
import useWizardSteps from "../../hooks/useWizardSteps";
import { setTechModelAction } from "../../redux/techModel.js";
import { setLifeExtraData } from "../../redux/lifeExtraData.js";
import { setHogarModel } from "../../redux/hogarModel";

const suggestion = (
  <span>
    <b>Revisá y confirmá</b> los datos
  </span>
);

export default function Summary() {
  const [submitForm, setSubmitForm] = useState(null);
  const dispatch = useDispatch();

  const {
    user,
    carInsurance,
    insuranceName,
    plan,
    techModel,
    token,
    id,
    pet,
    iva,
    iibb,
    activityName,
  } = useSelector(
    ({
      user,
      carInsurance,
      insurances,
      insurancePlans,
      techModel,
      auth,
      pet,
      taxes,
      activityName,
    }) => ({
      techModel: techModel.techModel,
      user,
      carInsurance,
      insuranceName: insurances.selected && insurances.selected.insuranceName,
      plan: insurancePlans.selected,
      token: auth.token,
      id: insurances.selected.insuranceProductId,
      pet: pet.pet,
      iva: taxes.taxes.condition,
      iibb: taxes.taxes.condition2,
      activityName: activityName.activityName.selected2,
    })
  );

  const stepWizard = () => {
    if (insuranceName === ("INTEGRAL DE COMERCIO" || "MASCOTA")) {
      return 4;
    } else if (insuranceName === "AUTOMOTOR") {
      return 5;
    } else {
      return 3;
    }
  };

  const [activeStep] = useWizardSteps(stepWizard());

  useEffect(() => {
    const getFreeDataFields = async () => {
      try {
        const { data } = await api.get(
          `/seguros/informacion/adicional/ch/PDS?code=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (data) {
          if (insuranceName === "TECNO") {
            const modeledTech =
              data.additionalDataBlocks[0].additionalDataBlock.additionalDatas.map(
                (item) => {
                  const tech = {
                    name: item.additionalData.code,
                  };

                  const description =
                    item.additionalData.description.toLowerCase();

                  if (
                    description === "marca del celular" ||
                    description === "marca de celular"
                  ) {
                    tech.value = techModel.phoneBrand;
                  } else if (
                    description === "modelo del celular" ||
                    description === "modelo de celular"
                  ) {
                    tech.value = techModel.phoneModel;
                  } else if (description === "marca de notebook") {
                    tech.value = techModel.techModel;
                  } else if (description === "modelo de notebook") {
                    tech.value = techModel.techBrand;
                  }

                  return tech;
                }
              );
            dispatch(setTechModelAction(modeledTech));
          } else if (insuranceName === "VIDA INDIVIDUAL") {
            const modeledData =
              data.additionalDataBlocks[0].additionalDataBlock.additionalDatas.map(
                (item) => {
                  return { name: item.additionalData.code, value: "N" };
                }
              );

            dispatch(setLifeExtraData(modeledData));
          } else if (insuranceName === 'HOGAR'){
            const modeledData =
              data.additionalDataBlocks[0].additionalDataBlock.additionalDatas.map(
                (item) => {
                  return { name: item.additionalData.code, value: item.additionalData.values };
                }
              );

            dispatch(setHogarModel(modeledData));
          }
        }
      } catch (error) {}
    };
    getFreeDataFields();
  }, []);

  return (
    <WizardLayout activeStep={activeStep} suggestion={suggestion}>
      <Grid item xs={12} container justify='center' spacing={3}>
        <Grid item xs={12} md={6} container>
          <Grid item xs={12} container>
            <PersonalInfoCard
              carData={carInsurance}
              userData={user}
              insuranceName={insuranceName}
              techData={insuranceName.toLowerCase() === "tecno" && techModel}
              petData={insuranceName.toLowerCase() === "mascota" && pet}
              taxIVA={iva}
              taxIIBB={iibb}
              activityName={activityName}
            />
          </Grid>
          <Hidden only={["xs", "sm"]}>
            <Grid item xs={12} container>
              <PersonalInfoForm submitForm={submitForm} />
            </Grid>
          </Hidden>
        </Grid>
        <Grid item xs={12} md={6} container>
          {insuranceName === "AUTOMOTOR" ? (
            <CoverageSummary
              price={plan.prize}
              coverage={plan.insuranceCoverages}
              planDescription={plan.longDesc}
              insuranceName={insuranceName.toLowerCase()}
            />
          ) : (
            <CoverageSummary
              price={plan.price}
              coverage={plan.insuranceCoverages}
              planDescription={plan.longDesc}
              insuranceName={insuranceName.toLowerCase()}
            />
          )}
        </Grid>
        <Hidden mdUp>
          <Grid item xs={12} container>
            <PersonalInfoForm submitForm={submitForm} />
          </Grid>
        </Hidden>
        <Grid item xs={12} container>
          <WizardNavigation nextAction={() => setSubmitForm(submitForm + 1)} />
        </Grid>
      </Grid>
    </WizardLayout>
  );
}
